import { render, staticRenderFns } from "./errorProblem.vue?vue&type=template&id=8b3efa16&scoped=true"
import script from "./errorProblem.vue?vue&type=script&lang=js"
export * from "./errorProblem.vue?vue&type=script&lang=js"
import style0 from "./errorProblem.vue?vue&type=style&index=0&id=8b3efa16&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3efa16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3efa16')) {
      api.createRecord('8b3efa16', component.options)
    } else {
      api.reload('8b3efa16', component.options)
    }
    module.hot.accept("./errorProblem.vue?vue&type=template&id=8b3efa16&scoped=true", function () {
      api.rerender('8b3efa16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/calssModule/errorProblem.vue"
export default component.exports